module.exports = __webpack_public_path__ + "static/media/norton.eddad130.png";